export default "__VITE_ASSET__eDj7fAUy__"